<template>
  <div>
    <form-user
      v-model="userData"
      @save="updateUser"
    />
  </div>
</template>

<script>
import AuthMixin from '../../mixins/auth';
import RolesMixin from '../../mixins/roles';
import FormMixin from '../../mixins/form';

export default {
  mixins: [
    AuthMixin,
    RolesMixin,
    FormMixin,
  ],

  data() {
    return {
      userData: {},
    };
  },

  computed: {
    locales() {
      return [
        // { text: 'French', value: 'fr' },
        { text: 'English', value: 'en' },
      ];
    },
  },

  mounted() {
    this.userData = _.clone(this.user);
  },

  methods: {
    refresh() {
      this.fetchRoles();
    },

    updateUser(user) {
      const { User } = this.$FeathersVuex.api;
      const newUser = new User(user);

      this.updateEntity(undefined, newUser);
    },
  },
};
</script>
